import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { MapPin, Phone, Facebook, Clock, Info } from 'lucide-react';
import { PHONE, PHONE_TEL, GOOGLE_MAPS_URL, ADDRESS_LINE_1, ADDRESS_LINE_2, FACEBOOK_URL } from '../constants/business';
export function Contact() {
  useDocumentMeta('Contact Kjergaard Sports | Lake Benton, Minnesota', 'Contact Kjergaard Sports in Lake Benton, Minnesota. Get directions, call the store, or check our Facebook page for hours and updates.');
  return <div data-id="element-321">
      <PageHero title="Contact Kjergaard Sports" image="https://cdn.magicpatterns.com/uploads/f5Jp1yjaV9t3nwDxVsC5wU/exterior-front-building.jpg" alt="Kjergaard Sports storefront in Lake Benton, Minnesota" data-id="element-322" />

      <section className="py-20 bg-brand-offwhite" data-id="element-323">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
          <div className="bg-brand-bone rounded-sm overflow-hidden shadow-sm border border-brand-cream" data-id="element-325">
            <div className="grid lg:grid-cols-2" data-id="element-326">
              {/* Contact Info */}
              <div className="p-10 lg:p-16" data-id="element-327">
                <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-8" data-id="element-328">
                  Visit Us in Lake Benton
                </h2>

                <div className="space-y-8 mb-10" data-id="element-329">
                  <div className="flex items-start" data-id="element-330">
                    <MapPin className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-331" />
                    <div data-id="element-332">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-333">
                        Address
                      </h3>
                      <p className="text-brand-charcoal/80" data-id="element-334">
                        Kjergaard Sports
                        <br data-id="element-335" />
                        {ADDRESS_LINE_1}
                        <br data-id="element-336" />
                        {ADDRESS_LINE_2}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-337">
                    <Phone className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-338" />
                    <div data-id="element-339">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-340">
                        Phone
                      </h3>
                      <a href={PHONE_TEL} className="text-brand-hunter hover:text-brand-wood font-medium text-lg transition-colors" data-id="element-341">
                        {PHONE}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-342">
                    <Clock className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-343" />
                    <div data-id="element-344">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-345">
                        Hours & Updates
                      </h3>
                      <p className="text-brand-charcoal/80" data-id="element-346">
                        Please call or check Facebook for current hours, class
                        dates, and store updates.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-4 mb-12" data-id="element-347">
                  <a href={PHONE_TEL} className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-348">
                    <Phone className="w-4 h-4 mr-2" data-id="element-349" />
                    Call the Store
                  </a>
                  <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="border border-brand-hunter text-brand-hunter hover:bg-brand-hunter hover:text-brand-offwhite px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-350">
                    <MapPin className="w-4 h-4 mr-2" data-id="element-351" />
                    Get Directions
                  </a>
                  <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="bg-[#1877F2] hover:bg-[#0c5dc7] text-white px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-352">
                    <Facebook className="w-4 h-4 mr-2" data-id="element-353" />
                    Follow on Facebook
                  </a>
                </div>

                {/* Need Help From the Store? */}
                <div className="pt-8 border-t border-brand-cream" data-id="element-354">
                  <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-355">
                    Need Help From the Store?
                  </h3>
                  <p className="text-brand-charcoal/80 leading-relaxed mb-5" data-id="element-356">
                    Call Kjergaard Sports, follow us on Facebook for current
                    updates, or use the directions link to plan your visit to
                    Lake Benton, Minnesota.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3" data-id="element-357">
                    <a href={PHONE_TEL} className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-5 py-2.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center text-sm" data-id="element-358">
                      <Phone className="w-4 h-4 mr-2" data-id="element-359" />
                      Call {PHONE}
                    </a>
                    <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="border border-brand-charcoal/20 hover:border-brand-leather hover:text-brand-leather text-brand-charcoal px-5 py-2.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center text-sm" data-id="element-360">
                      <Facebook className="w-4 h-4 mr-2" data-id="element-361" />
                      Follow on Facebook
                    </a>
                    <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="border border-brand-charcoal/20 hover:border-brand-leather hover:text-brand-leather text-brand-charcoal px-5 py-2.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center text-sm" data-id="element-362">
                      <MapPin className="w-4 h-4 mr-2" data-id="element-363" />
                      Get Directions
                    </a>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-brand-cream relative min-h-[400px] flex items-center justify-center p-8 border-l border-brand-cream overflow-hidden" data-id="element-364">
                <img src="https://cdn.magicpatterns.com/uploads/f5Jp1yjaV9t3nwDxVsC5wU/exterior-front-building.jpg" alt="Kjergaard Sports exterior" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-365" />
                <div className="relative z-10 text-center bg-brand-offwhite/95 backdrop-blur-sm p-10 rounded-sm shadow-md border border-brand-bone max-w-sm w-full" data-id="element-366">
                  <MapPin className="w-12 h-12 text-brand-hunter mx-auto mb-4" data-id="element-367" />
                  <h3 className="text-2xl font-serif text-brand-charcoal mb-2" data-id="element-368">
                    Find Us in Lake Benton
                  </h3>
                  <p className="text-brand-charcoal/70 mb-8" data-id="element-369">
                    Located in rural Minnesota, offering a massive selection
                    worth the drive.
                  </p>
                  <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-brand-hunter text-brand-offwhite px-6 py-3 rounded-sm font-medium hover:bg-brand-wood transition-colors" data-id="element-370">
                    <MapPin className="w-4 h-4 mr-2" data-id="element-371" />
                    View on Google Maps
                  </a>
                  <p className="text-brand-charcoal/70 text-xs leading-relaxed mt-5 text-left" data-id="element-372">
                    <strong data-id="element-373">Heads up:</strong> Google Maps may misplace our
                    address pin (sometimes to a grove, the Lake Benton city
                    limits, or a nearby welding shop). Use the Kjergaard Sports
                    Google Business listing when available, or call{' '}
                    <a href={PHONE_TEL} className="text-brand-hunter font-medium hover:text-brand-wood" data-id="element-374">
                      {PHONE}
                    </a>{' '}
                    if you need help finding the store.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/*
           IMPLEMENTATION NOTE (not customer-facing):
           Final WebsiteForge setup should replace the directions URL with the exact
           Kjergaard Sports Google Business Profile / Place link once provided, to
           avoid Google Maps placing the pin at the wrong location. Contact form
           submissions should also be connected in WebsiteForge final implementation.
           */}
        </div>
      </section>
    </div>;
}